module.exports = __webpack_public_path__ + "static/img/lj_09.c6bfc16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lj_09.jpg
// module id = FG8p
// module chunks = 1